<template>
  <!-- NOTE (TEMPLATE) to show all proposals -->

  <div class="animated fadeIn">
    <b-card
      v-if="$router.currentRoute.path == '/university/activeRequests'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <div class="d-flex justify-content-right mb-3">
        <!-- NOTE (<a>) to define a new proposal -->
        <router-link
          class="btn btn-primary text-light"
          to="/university/newUniRequest"
          >تعریف طرح کلان جدید</router-link
        >
      </div>
      <h6>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h6>

      <!-- NOTE (t-proposals) to show all proposals -->
      <b-table
        responsive
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="items"
        empty-text="هنوز درخواستی ثبت نشده است"
        striped
        :busy="isBusy"
        :filter="filter"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(operation)="data">
          <!-- NOTE (<a>) button of "ersal e eslahieh" -->
          <div style="text-align: center; vertical-align: middle; width: 150px">
            <a
              class="btn btn-warning mx-1"
              style="width: 100%"
              :href="'/university/completeUniRequest/' + data.item.id"
              v-if="data.item.status == 'نیاز به تکمیل / اصلاح'"
              >ارسال اصلاحیه</a
            >

            <a
              class="btn btn-secondary mx-1"
              :href="'/university/completeUniRequest/' + data.item.id"
              v-if="data.item.status == 'پیش نویس'"
              style="width: 100%"
              target="_blank"
              >تکمیل درخواست</a
            >
            <a
              class="btn btn-primary text-light mx-1"
              :href="'/university/uniRequest/' + data.item.id"
              v-if="data.item.status != 'پیش نویس'"
              style="width: 100%"
              >مشاهده درخواست</a
            >

            <b-button
              v-if="
                data.item.status == 'ثبت شده' || data.item.status == 'پیش نویس'
              "
              class="btn btn-danger mx-1 mt-1"
              style="width: 100%"
              :disabled="isBusy"
              @click="cancelProposal(data.item)"
              >لغو درخواست</b-button
            >
          </div>
        </template>
        <template v-slot:cell(status)="data">
          <div
            v-if="data.item.status == 'پیش نویس'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-yahoo p-2" disabled
              >پیش نویس</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'ثبت شده'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-vimeo p-2" disabled
              >ثبت شده</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'درحال بررسی'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-xing p-2" disabled
              >درحال بررسی</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'در دست داوری'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-css3 p-2" disabled
              >در دست داوری</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'جمع بندی نظرات داوران'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-warning p-2" disabled
              >جمع بندی نظرات داوران</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'تایید نهایی'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-success" disabled
              >تایید نهایی</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'اصلاح شده'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-flickr" disabled
              >اصلاح شده</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'مرحله دوم'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-dark" disabled
              >مرحله دوم</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'نیاز به تکمیل / اصلاح'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-danger" disabled
              >نیاز به تکمیل / اصلاح</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'پذیرش اولیه'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-info p-2" disabled
              >پذیرش اولیه</b-button
            >
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  data: function () {
    return {
      fields: [
        { key: "index", label: "ردیف" },
        { key: "faSubject", label: "عنوان فارسی" },
        { key: "cat", label: "موضوع درخواست" },
        { key: "requestsCode", label: "کد درخواست" },
        { key: "registerDate", label: "تاریخ ثبت" },
        { key: "status", label: "وضعیت" },
        { key: "version", label: "نسخه" },
        { key: "lastUpdate", label: "آخرین بروزرسانی" },
        { key: "operation", label: "عملیات" },
      ],
      items: [],
      filter: "",
      isBusy: true,
      selectedItem: "",
    };
  },
  methods: {
    getData() {
      // NOTE (m-getData) to get proposals data to show them
      this.isBusy = true;
      this.$http
        .get(this.baseUrl + "/setad/university/uniRequests/actives", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.items = res.data;
          this.isBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    cancelProposal(item) {
      this.isBusy = true;
      this.$http
        .patch(
          `${this.baseUrl}/setad/university/uniRequest/cancel/${item.id}`,
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.getData();
        })
        .catch((err) => {
          this.toast(
            err.response.data + ". لطفا با پشتیبانی تماس بگیرید.",
            "error"
          );
          this.isBusy = false;
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.bg-primary {
  background-color: #693d70 !important;
}
.color {
  background-color: #0c4961;
  color: white;
}
</style>
